export const DEFAULT_DASHBOARD_PERIOD = "last_6_months";
export const DASHBOARD_PERIOD_STORAGE_KEY = "finflo.dashboard.period";

export const DASHBOARD_PERIOD_OPTIONS = [
  { value: "this_month", label: "This Month" },
  { value: "last_3_months", label: "Last 3 Months" },
  { value: "last_6_months", label: "Last 6 Months" },
  { value: "this_year", label: "This Year" },
  { value: "all_time", label: "All Time" },
];

const DASHBOARD_PERIODS = new Set(
  DASHBOARD_PERIOD_OPTIONS.map(({ value }) => value),
);

const browserStorage = () => (
  typeof window === "undefined" ? null : window.localStorage
);

export function loadDashboardPeriod(storage) {
  try {
    const selectedStorage = storage === undefined ? browserStorage() : storage;
    const savedPeriod = selectedStorage?.getItem(DASHBOARD_PERIOD_STORAGE_KEY);
    return DASHBOARD_PERIODS.has(savedPeriod)
      ? savedPeriod
      : DEFAULT_DASHBOARD_PERIOD;
  } catch {
    return DEFAULT_DASHBOARD_PERIOD;
  }
}

export function saveDashboardPeriod(period, storage) {
  try {
    const selectedStorage = storage === undefined ? browserStorage() : storage;
    if (DASHBOARD_PERIODS.has(period)) {
      selectedStorage?.setItem(DASHBOARD_PERIOD_STORAGE_KEY, period);
    }
  } catch {
    // The selector should still work when storage is disabled or unavailable.
  }
}
